/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as LandingRouteRouteImport } from './routes/_landing/route'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as AppBestillingRouteRouteImport } from './routes/_app/bestilling/route'
import { Route as AppSelskapRouteImport } from './routes/_app/selskap'
import { Route as LandingIndexRouteImport } from './routes/_landing/index'
import { Route as LandingKundestChar248tteRouteImport } from './routes/_landing/kundestøtte'
import { Route as LandingVilkChar229rRouteImport } from './routes/_landing/vilkår'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthLoggInnRouteImport } from './routes/auth/logg-inn'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AppAvtalerIndexRouteImport } from './routes/_app/avtaler/index'
import { Route as AppBestillingNyRouteRouteImport } from './routes/_app/bestilling/ny/route'
import { Route as AppBestillingNyAktoerIndexRouteImport } from './routes/_app/bestilling/ny/aktoer.index'
import { Route as AppBestillingNyBestillerIndexRouteImport } from './routes/_app/bestilling/ny/bestiller.index'
import { Route as AppBestillingNyFinnLeverandoerIndexRouteImport } from './routes/_app/bestilling/ny/finn-leverandoer.index'
import { Route as AppBestillingNyInformasjonIndexRouteImport } from './routes/_app/bestilling/ny/informasjon.index'
import { Route as AppBestillingNyOppsummeringIndexRouteImport } from './routes/_app/bestilling/ny/oppsummering.index'
import { Route as AppBestillingNyPeriodeIndexRouteImport } from './routes/_app/bestilling/ny/periode.index'
import { Route as AppAvtalerAvtalerIdPrivatAvbestillIndexRouteImport } from './routes/_app/avtaler/$avtalerId/privat/avbestill.index'
import { Route as AppAvtalerAvtalerIdPrivatBekreftelseIndexRouteImport } from './routes/_app/avtaler/$avtalerId/privat/bekreftelse.index'
import { Route as AppAvtalerAvtalerIdPrivatEndreIndexRouteImport } from './routes/_app/avtaler/$avtalerId/privat/endre.index'
import { Route as AppAvtalerAvtalerIdSelskapAvbestillIndexRouteImport } from './routes/_app/avtaler/$avtalerId/selskap/avbestill.index'
import { Route as AppAvtalerAvtalerIdSelskapBekreftelseIndexRouteImport } from './routes/_app/avtaler/$avtalerId/selskap/bekreftelse.index'
import { Route as AppAvtalerAvtalerIdSelskapEndreIndexRouteImport } from './routes/_app/avtaler/$avtalerId/selskap/endre.index'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRouteRoute = LandingRouteRouteImport.update({
  id: '/_landing',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBestillingRouteRoute = AppBestillingRouteRouteImport.update({
  id: '/bestilling',
  path: '/bestilling',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSelskapRoute = AppSelskapRouteImport.update({
  id: '/selskap',
  path: '/selskap',
  getParentRoute: () => AppRouteRoute,
} as any)
const LandingIndexRoute = LandingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LandingRouteRoute,
} as any)
const LandingKundestChar248tteRoute =
  LandingKundestChar248tteRouteImport.update({
    id: '/kundestøtte',
    path: '/kundestøtte',
    getParentRoute: () => LandingRouteRoute,
  } as any)
const LandingVilkChar229rRoute = LandingVilkChar229rRouteImport.update({
  id: '/vilkår',
  path: '/vilkår',
  getParentRoute: () => LandingRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoggInnRoute = AuthLoggInnRouteImport.update({
  id: '/auth/logg-inn',
  path: '/auth/logg-inn',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAvtalerIndexRoute = AppAvtalerIndexRouteImport.update({
  id: '/avtaler/',
  path: '/avtaler/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBestillingNyRouteRoute = AppBestillingNyRouteRouteImport.update({
  id: '/ny',
  path: '/ny',
  getParentRoute: () => AppBestillingRouteRoute,
} as any)
const AppBestillingNyAktoerIndexRoute =
  AppBestillingNyAktoerIndexRouteImport.update({
    id: '/aktoer/',
    path: '/aktoer/',
    getParentRoute: () => AppBestillingNyRouteRoute,
  } as any)
const AppBestillingNyBestillerIndexRoute =
  AppBestillingNyBestillerIndexRouteImport.update({
    id: '/bestiller/',
    path: '/bestiller/',
    getParentRoute: () => AppBestillingNyRouteRoute,
  } as any)
const AppBestillingNyFinnLeverandoerIndexRoute =
  AppBestillingNyFinnLeverandoerIndexRouteImport.update({
    id: '/finn-leverandoer/',
    path: '/finn-leverandoer/',
    getParentRoute: () => AppBestillingNyRouteRoute,
  } as any)
const AppBestillingNyInformasjonIndexRoute =
  AppBestillingNyInformasjonIndexRouteImport.update({
    id: '/informasjon/',
    path: '/informasjon/',
    getParentRoute: () => AppBestillingNyRouteRoute,
  } as any)
const AppBestillingNyOppsummeringIndexRoute =
  AppBestillingNyOppsummeringIndexRouteImport.update({
    id: '/oppsummering/',
    path: '/oppsummering/',
    getParentRoute: () => AppBestillingNyRouteRoute,
  } as any)
const AppBestillingNyPeriodeIndexRoute =
  AppBestillingNyPeriodeIndexRouteImport.update({
    id: '/periode/',
    path: '/periode/',
    getParentRoute: () => AppBestillingNyRouteRoute,
  } as any)
const AppAvtalerAvtalerIdPrivatAvbestillIndexRoute =
  AppAvtalerAvtalerIdPrivatAvbestillIndexRouteImport.update({
    id: '/avtaler/$avtalerId/privat/avbestill/',
    path: '/avtaler/$avtalerId/privat/avbestill/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute =
  AppAvtalerAvtalerIdPrivatBekreftelseIndexRouteImport.update({
    id: '/avtaler/$avtalerId/privat/bekreftelse/',
    path: '/avtaler/$avtalerId/privat/bekreftelse/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAvtalerAvtalerIdPrivatEndreIndexRoute =
  AppAvtalerAvtalerIdPrivatEndreIndexRouteImport.update({
    id: '/avtaler/$avtalerId/privat/endre/',
    path: '/avtaler/$avtalerId/privat/endre/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAvtalerAvtalerIdSelskapAvbestillIndexRoute =
  AppAvtalerAvtalerIdSelskapAvbestillIndexRouteImport.update({
    id: '/avtaler/$avtalerId/selskap/avbestill/',
    path: '/avtaler/$avtalerId/selskap/avbestill/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute =
  AppAvtalerAvtalerIdSelskapBekreftelseIndexRouteImport.update({
    id: '/avtaler/$avtalerId/selskap/bekreftelse/',
    path: '/avtaler/$avtalerId/selskap/bekreftelse/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAvtalerAvtalerIdSelskapEndreIndexRoute =
  AppAvtalerAvtalerIdSelskapEndreIndexRouteImport.update({
    id: '/avtaler/$avtalerId/selskap/endre/',
    path: '/avtaler/$avtalerId/selskap/endre/',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LandingIndexRoute
  '/debug': typeof DebugRoute
  '/bestilling': typeof AppBestillingRouteRouteWithChildren
  '/selskap': typeof AppSelskapRoute
  '/kundestøtte': typeof LandingKundestChar248tteRoute
  '/vilkår': typeof LandingVilkChar229rRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/logg-inn': typeof AuthLoggInnRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/bestilling/ny': typeof AppBestillingNyRouteRouteWithChildren
  '/avtaler/': typeof AppAvtalerIndexRoute
  '/bestilling/ny/aktoer/': typeof AppBestillingNyAktoerIndexRoute
  '/bestilling/ny/bestiller/': typeof AppBestillingNyBestillerIndexRoute
  '/bestilling/ny/finn-leverandoer/': typeof AppBestillingNyFinnLeverandoerIndexRoute
  '/bestilling/ny/informasjon/': typeof AppBestillingNyInformasjonIndexRoute
  '/bestilling/ny/oppsummering/': typeof AppBestillingNyOppsummeringIndexRoute
  '/bestilling/ny/periode/': typeof AppBestillingNyPeriodeIndexRoute
  '/avtaler/$avtalerId/privat/avbestill/': typeof AppAvtalerAvtalerIdPrivatAvbestillIndexRoute
  '/avtaler/$avtalerId/privat/bekreftelse/': typeof AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute
  '/avtaler/$avtalerId/privat/endre/': typeof AppAvtalerAvtalerIdPrivatEndreIndexRoute
  '/avtaler/$avtalerId/selskap/avbestill/': typeof AppAvtalerAvtalerIdSelskapAvbestillIndexRoute
  '/avtaler/$avtalerId/selskap/bekreftelse/': typeof AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute
  '/avtaler/$avtalerId/selskap/endre/': typeof AppAvtalerAvtalerIdSelskapEndreIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LandingIndexRoute
  '/debug': typeof DebugRoute
  '/bestilling': typeof AppBestillingRouteRouteWithChildren
  '/selskap': typeof AppSelskapRoute
  '/kundestøtte': typeof LandingKundestChar248tteRoute
  '/vilkår': typeof LandingVilkChar229rRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/logg-inn': typeof AuthLoggInnRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/bestilling/ny': typeof AppBestillingNyRouteRouteWithChildren
  '/avtaler': typeof AppAvtalerIndexRoute
  '/bestilling/ny/aktoer': typeof AppBestillingNyAktoerIndexRoute
  '/bestilling/ny/bestiller': typeof AppBestillingNyBestillerIndexRoute
  '/bestilling/ny/finn-leverandoer': typeof AppBestillingNyFinnLeverandoerIndexRoute
  '/bestilling/ny/informasjon': typeof AppBestillingNyInformasjonIndexRoute
  '/bestilling/ny/oppsummering': typeof AppBestillingNyOppsummeringIndexRoute
  '/bestilling/ny/periode': typeof AppBestillingNyPeriodeIndexRoute
  '/avtaler/$avtalerId/privat/avbestill': typeof AppAvtalerAvtalerIdPrivatAvbestillIndexRoute
  '/avtaler/$avtalerId/privat/bekreftelse': typeof AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute
  '/avtaler/$avtalerId/privat/endre': typeof AppAvtalerAvtalerIdPrivatEndreIndexRoute
  '/avtaler/$avtalerId/selskap/avbestill': typeof AppAvtalerAvtalerIdSelskapAvbestillIndexRoute
  '/avtaler/$avtalerId/selskap/bekreftelse': typeof AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute
  '/avtaler/$avtalerId/selskap/endre': typeof AppAvtalerAvtalerIdSelskapEndreIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_landing': typeof LandingRouteRouteWithChildren
  '/debug': typeof DebugRoute
  '/_app/bestilling': typeof AppBestillingRouteRouteWithChildren
  '/_app/selskap': typeof AppSelskapRoute
  '/_landing/kundestøtte': typeof LandingKundestChar248tteRoute
  '/_landing/vilkår': typeof LandingVilkChar229rRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/logg-inn': typeof AuthLoggInnRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/_landing/': typeof LandingIndexRoute
  '/_app/bestilling/ny': typeof AppBestillingNyRouteRouteWithChildren
  '/_app/avtaler/': typeof AppAvtalerIndexRoute
  '/_app/bestilling/ny/aktoer/': typeof AppBestillingNyAktoerIndexRoute
  '/_app/bestilling/ny/bestiller/': typeof AppBestillingNyBestillerIndexRoute
  '/_app/bestilling/ny/finn-leverandoer/': typeof AppBestillingNyFinnLeverandoerIndexRoute
  '/_app/bestilling/ny/informasjon/': typeof AppBestillingNyInformasjonIndexRoute
  '/_app/bestilling/ny/oppsummering/': typeof AppBestillingNyOppsummeringIndexRoute
  '/_app/bestilling/ny/periode/': typeof AppBestillingNyPeriodeIndexRoute
  '/_app/avtaler/$avtalerId/privat/avbestill/': typeof AppAvtalerAvtalerIdPrivatAvbestillIndexRoute
  '/_app/avtaler/$avtalerId/privat/bekreftelse/': typeof AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute
  '/_app/avtaler/$avtalerId/privat/endre/': typeof AppAvtalerAvtalerIdPrivatEndreIndexRoute
  '/_app/avtaler/$avtalerId/selskap/avbestill/': typeof AppAvtalerAvtalerIdSelskapAvbestillIndexRoute
  '/_app/avtaler/$avtalerId/selskap/bekreftelse/': typeof AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute
  '/_app/avtaler/$avtalerId/selskap/endre/': typeof AppAvtalerAvtalerIdSelskapEndreIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/debug'
    | '/bestilling'
    | '/selskap'
    | '/kundestøtte'
    | '/vilkår'
    | '/auth/callback'
    | '/auth/logg-inn'
    | '/auth/login'
    | '/auth/logout'
    | '/bestilling/ny'
    | '/avtaler/'
    | '/bestilling/ny/aktoer/'
    | '/bestilling/ny/bestiller/'
    | '/bestilling/ny/finn-leverandoer/'
    | '/bestilling/ny/informasjon/'
    | '/bestilling/ny/oppsummering/'
    | '/bestilling/ny/periode/'
    | '/avtaler/$avtalerId/privat/avbestill/'
    | '/avtaler/$avtalerId/privat/bekreftelse/'
    | '/avtaler/$avtalerId/privat/endre/'
    | '/avtaler/$avtalerId/selskap/avbestill/'
    | '/avtaler/$avtalerId/selskap/bekreftelse/'
    | '/avtaler/$avtalerId/selskap/endre/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/debug'
    | '/bestilling'
    | '/selskap'
    | '/kundestøtte'
    | '/vilkår'
    | '/auth/callback'
    | '/auth/logg-inn'
    | '/auth/login'
    | '/auth/logout'
    | '/bestilling/ny'
    | '/avtaler'
    | '/bestilling/ny/aktoer'
    | '/bestilling/ny/bestiller'
    | '/bestilling/ny/finn-leverandoer'
    | '/bestilling/ny/informasjon'
    | '/bestilling/ny/oppsummering'
    | '/bestilling/ny/periode'
    | '/avtaler/$avtalerId/privat/avbestill'
    | '/avtaler/$avtalerId/privat/bekreftelse'
    | '/avtaler/$avtalerId/privat/endre'
    | '/avtaler/$avtalerId/selskap/avbestill'
    | '/avtaler/$avtalerId/selskap/bekreftelse'
    | '/avtaler/$avtalerId/selskap/endre'
  id:
    | '__root__'
    | '/_app'
    | '/_landing'
    | '/debug'
    | '/_app/bestilling'
    | '/_app/selskap'
    | '/_landing/kundestøtte'
    | '/_landing/vilkår'
    | '/auth/callback'
    | '/auth/logg-inn'
    | '/auth/login'
    | '/auth/logout'
    | '/_landing/'
    | '/_app/bestilling/ny'
    | '/_app/avtaler/'
    | '/_app/bestilling/ny/aktoer/'
    | '/_app/bestilling/ny/bestiller/'
    | '/_app/bestilling/ny/finn-leverandoer/'
    | '/_app/bestilling/ny/informasjon/'
    | '/_app/bestilling/ny/oppsummering/'
    | '/_app/bestilling/ny/periode/'
    | '/_app/avtaler/$avtalerId/privat/avbestill/'
    | '/_app/avtaler/$avtalerId/privat/bekreftelse/'
    | '/_app/avtaler/$avtalerId/privat/endre/'
    | '/_app/avtaler/$avtalerId/selskap/avbestill/'
    | '/_app/avtaler/$avtalerId/selskap/bekreftelse/'
    | '/_app/avtaler/$avtalerId/selskap/endre/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LandingRouteRoute: typeof LandingRouteRouteWithChildren
  DebugRoute: typeof DebugRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoggInnRoute: typeof AuthLoggInnRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_landing': {
      id: '/_landing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LandingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/bestilling': {
      id: '/_app/bestilling'
      path: '/bestilling'
      fullPath: '/bestilling'
      preLoaderRoute: typeof AppBestillingRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/selskap': {
      id: '/_app/selskap'
      path: '/selskap'
      fullPath: '/selskap'
      preLoaderRoute: typeof AppSelskapRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_landing/': {
      id: '/_landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LandingIndexRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/_landing/kundestøtte': {
      id: '/_landing/kundestøtte'
      path: '/kundestøtte'
      fullPath: '/kundestøtte'
      preLoaderRoute: typeof LandingKundestChar248tteRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/_landing/vilkår': {
      id: '/_landing/vilkår'
      path: '/vilkår'
      fullPath: '/vilkår'
      preLoaderRoute: typeof LandingVilkChar229rRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logg-inn': {
      id: '/auth/logg-inn'
      path: '/auth/logg-inn'
      fullPath: '/auth/logg-inn'
      preLoaderRoute: typeof AuthLoggInnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/avtaler/': {
      id: '/_app/avtaler/'
      path: '/avtaler'
      fullPath: '/avtaler/'
      preLoaderRoute: typeof AppAvtalerIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/bestilling/ny': {
      id: '/_app/bestilling/ny'
      path: '/ny'
      fullPath: '/bestilling/ny'
      preLoaderRoute: typeof AppBestillingNyRouteRouteImport
      parentRoute: typeof AppBestillingRouteRoute
    }
    '/_app/bestilling/ny/aktoer/': {
      id: '/_app/bestilling/ny/aktoer/'
      path: '/aktoer'
      fullPath: '/bestilling/ny/aktoer/'
      preLoaderRoute: typeof AppBestillingNyAktoerIndexRouteImport
      parentRoute: typeof AppBestillingNyRouteRoute
    }
    '/_app/bestilling/ny/bestiller/': {
      id: '/_app/bestilling/ny/bestiller/'
      path: '/bestiller'
      fullPath: '/bestilling/ny/bestiller/'
      preLoaderRoute: typeof AppBestillingNyBestillerIndexRouteImport
      parentRoute: typeof AppBestillingNyRouteRoute
    }
    '/_app/bestilling/ny/finn-leverandoer/': {
      id: '/_app/bestilling/ny/finn-leverandoer/'
      path: '/finn-leverandoer'
      fullPath: '/bestilling/ny/finn-leverandoer/'
      preLoaderRoute: typeof AppBestillingNyFinnLeverandoerIndexRouteImport
      parentRoute: typeof AppBestillingNyRouteRoute
    }
    '/_app/bestilling/ny/informasjon/': {
      id: '/_app/bestilling/ny/informasjon/'
      path: '/informasjon'
      fullPath: '/bestilling/ny/informasjon/'
      preLoaderRoute: typeof AppBestillingNyInformasjonIndexRouteImport
      parentRoute: typeof AppBestillingNyRouteRoute
    }
    '/_app/bestilling/ny/oppsummering/': {
      id: '/_app/bestilling/ny/oppsummering/'
      path: '/oppsummering'
      fullPath: '/bestilling/ny/oppsummering/'
      preLoaderRoute: typeof AppBestillingNyOppsummeringIndexRouteImport
      parentRoute: typeof AppBestillingNyRouteRoute
    }
    '/_app/bestilling/ny/periode/': {
      id: '/_app/bestilling/ny/periode/'
      path: '/periode'
      fullPath: '/bestilling/ny/periode/'
      preLoaderRoute: typeof AppBestillingNyPeriodeIndexRouteImport
      parentRoute: typeof AppBestillingNyRouteRoute
    }
    '/_app/avtaler/$avtalerId/privat/avbestill/': {
      id: '/_app/avtaler/$avtalerId/privat/avbestill/'
      path: '/avtaler/$avtalerId/privat/avbestill'
      fullPath: '/avtaler/$avtalerId/privat/avbestill/'
      preLoaderRoute: typeof AppAvtalerAvtalerIdPrivatAvbestillIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/avtaler/$avtalerId/privat/bekreftelse/': {
      id: '/_app/avtaler/$avtalerId/privat/bekreftelse/'
      path: '/avtaler/$avtalerId/privat/bekreftelse'
      fullPath: '/avtaler/$avtalerId/privat/bekreftelse/'
      preLoaderRoute: typeof AppAvtalerAvtalerIdPrivatBekreftelseIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/avtaler/$avtalerId/privat/endre/': {
      id: '/_app/avtaler/$avtalerId/privat/endre/'
      path: '/avtaler/$avtalerId/privat/endre'
      fullPath: '/avtaler/$avtalerId/privat/endre/'
      preLoaderRoute: typeof AppAvtalerAvtalerIdPrivatEndreIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/avtaler/$avtalerId/selskap/avbestill/': {
      id: '/_app/avtaler/$avtalerId/selskap/avbestill/'
      path: '/avtaler/$avtalerId/selskap/avbestill'
      fullPath: '/avtaler/$avtalerId/selskap/avbestill/'
      preLoaderRoute: typeof AppAvtalerAvtalerIdSelskapAvbestillIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/avtaler/$avtalerId/selskap/bekreftelse/': {
      id: '/_app/avtaler/$avtalerId/selskap/bekreftelse/'
      path: '/avtaler/$avtalerId/selskap/bekreftelse'
      fullPath: '/avtaler/$avtalerId/selskap/bekreftelse/'
      preLoaderRoute: typeof AppAvtalerAvtalerIdSelskapBekreftelseIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/avtaler/$avtalerId/selskap/endre/': {
      id: '/_app/avtaler/$avtalerId/selskap/endre/'
      path: '/avtaler/$avtalerId/selskap/endre'
      fullPath: '/avtaler/$avtalerId/selskap/endre/'
      preLoaderRoute: typeof AppAvtalerAvtalerIdSelskapEndreIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppBestillingNyRouteRouteChildren {
  AppBestillingNyAktoerIndexRoute: typeof AppBestillingNyAktoerIndexRoute
  AppBestillingNyBestillerIndexRoute: typeof AppBestillingNyBestillerIndexRoute
  AppBestillingNyFinnLeverandoerIndexRoute: typeof AppBestillingNyFinnLeverandoerIndexRoute
  AppBestillingNyInformasjonIndexRoute: typeof AppBestillingNyInformasjonIndexRoute
  AppBestillingNyOppsummeringIndexRoute: typeof AppBestillingNyOppsummeringIndexRoute
  AppBestillingNyPeriodeIndexRoute: typeof AppBestillingNyPeriodeIndexRoute
}

const AppBestillingNyRouteRouteChildren: AppBestillingNyRouteRouteChildren = {
  AppBestillingNyAktoerIndexRoute: AppBestillingNyAktoerIndexRoute,
  AppBestillingNyBestillerIndexRoute: AppBestillingNyBestillerIndexRoute,
  AppBestillingNyFinnLeverandoerIndexRoute:
    AppBestillingNyFinnLeverandoerIndexRoute,
  AppBestillingNyInformasjonIndexRoute: AppBestillingNyInformasjonIndexRoute,
  AppBestillingNyOppsummeringIndexRoute: AppBestillingNyOppsummeringIndexRoute,
  AppBestillingNyPeriodeIndexRoute: AppBestillingNyPeriodeIndexRoute,
}

const AppBestillingNyRouteRouteWithChildren =
  AppBestillingNyRouteRoute._addFileChildren(AppBestillingNyRouteRouteChildren)

interface AppBestillingRouteRouteChildren {
  AppBestillingNyRouteRoute: typeof AppBestillingNyRouteRouteWithChildren
}

const AppBestillingRouteRouteChildren: AppBestillingRouteRouteChildren = {
  AppBestillingNyRouteRoute: AppBestillingNyRouteRouteWithChildren,
}

const AppBestillingRouteRouteWithChildren =
  AppBestillingRouteRoute._addFileChildren(AppBestillingRouteRouteChildren)

interface AppRouteRouteChildren {
  AppBestillingRouteRoute: typeof AppBestillingRouteRouteWithChildren
  AppSelskapRoute: typeof AppSelskapRoute
  AppAvtalerIndexRoute: typeof AppAvtalerIndexRoute
  AppAvtalerAvtalerIdPrivatAvbestillIndexRoute: typeof AppAvtalerAvtalerIdPrivatAvbestillIndexRoute
  AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute: typeof AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute
  AppAvtalerAvtalerIdPrivatEndreIndexRoute: typeof AppAvtalerAvtalerIdPrivatEndreIndexRoute
  AppAvtalerAvtalerIdSelskapAvbestillIndexRoute: typeof AppAvtalerAvtalerIdSelskapAvbestillIndexRoute
  AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute: typeof AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute
  AppAvtalerAvtalerIdSelskapEndreIndexRoute: typeof AppAvtalerAvtalerIdSelskapEndreIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBestillingRouteRoute: AppBestillingRouteRouteWithChildren,
  AppSelskapRoute: AppSelskapRoute,
  AppAvtalerIndexRoute: AppAvtalerIndexRoute,
  AppAvtalerAvtalerIdPrivatAvbestillIndexRoute:
    AppAvtalerAvtalerIdPrivatAvbestillIndexRoute,
  AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute:
    AppAvtalerAvtalerIdPrivatBekreftelseIndexRoute,
  AppAvtalerAvtalerIdPrivatEndreIndexRoute:
    AppAvtalerAvtalerIdPrivatEndreIndexRoute,
  AppAvtalerAvtalerIdSelskapAvbestillIndexRoute:
    AppAvtalerAvtalerIdSelskapAvbestillIndexRoute,
  AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute:
    AppAvtalerAvtalerIdSelskapBekreftelseIndexRoute,
  AppAvtalerAvtalerIdSelskapEndreIndexRoute:
    AppAvtalerAvtalerIdSelskapEndreIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface LandingRouteRouteChildren {
  LandingKundestChar248tteRoute: typeof LandingKundestChar248tteRoute
  LandingVilkChar229rRoute: typeof LandingVilkChar229rRoute
  LandingIndexRoute: typeof LandingIndexRoute
}

const LandingRouteRouteChildren: LandingRouteRouteChildren = {
  LandingKundestChar248tteRoute: LandingKundestChar248tteRoute,
  LandingVilkChar229rRoute: LandingVilkChar229rRoute,
  LandingIndexRoute: LandingIndexRoute,
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(
  LandingRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  LandingRouteRoute: LandingRouteRouteWithChildren,
  DebugRoute: DebugRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoggInnRoute: AuthLoggInnRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
